import React, { useCallback, useState } from 'react';
import { Backdrop, CircularProgress, Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';
import { getWorkOrderLink } from 'src/utils/MailOrbitService';
import { openWorkOrderId } from 'src/components/MailOrbit/StandaloneConversation/linkedWorkOrder';
import { openWorkOrder, WORK_ORDER_NOT_ACCESSIBLE_KEY } from 'src/components/MailOrbit/openWorkOrder';

/**
 * Listeden / bildirimden conversation acma (SR-024).
 *   - ACIK bagli is emri varsa (GET MailOrbitWorkOrder/{id}): is emri ekraninin MailOrbit E-mail sekmesi
 *     (Email2Case on kosullariyla, bkz. openWorkOrder; erisilemezse mesaj gosterilir, yonlendirme olmaz),
 *   - yoksa, bagli is emri kapaliysa veya istek hata verirse: bagimsiz gorunum
 *     (/MailOrbitConversation/:id; hata varsa orada gosterilir).
 * Mail icerigi cekilmez.
 */
const resolveOpenWorkOrderId = async ({ conversationId }) => {
  try {
    return openWorkOrderId(await getWorkOrderLink(conversationId));
  } catch (e) {
    return null; // bagimsiz gorunum hatayi kendisi gosterir
  }
};

/**
 * Kullanim: const { openConversation, conversationDialog } = useOpenConversation(history);
 * Donen `conversationDialog` (yonlendirme sirasindaki yukleniyor katmani) render edilmelidir.
 */
// eslint-disable-next-line import/prefer-default-export
export const useOpenConversation = history => {
  const { t } = useTranslation('mailorbitManual');
  const [resolving, setResolving] = useState(false);
  const [notAccessible, setNotAccessible] = useState(false);

  const openConversation = useCallback(
    async ref => {
      if (resolving || !history) return;
      setResolving(true);
      setNotAccessible(false);
      const workOrderId = await resolveOpenWorkOrderId(ref); // asla reddetmez
      if (workOrderId) {
        const opened = await openWorkOrder(history, workOrderId); // asla reddetmez
        setResolving(false);
        if (!opened) setNotAccessible(true);
        return;
      }
      setResolving(false);
      history.push(`/MailOrbitConversation/${encodeURIComponent(ref.conversationId)}`);
    },
    [history, resolving]
  );

  const conversationDialog = (
    <>
      <Backdrop open={resolving} style={{ zIndex: 1300, color: '#fff' }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={notAccessible}
        autoHideDuration={6000}
        onClose={() => setNotAccessible(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity="error" onClose={() => setNotAccessible(false)}>
          {t(WORK_ORDER_NOT_ACCESSIBLE_KEY)}
        </Alert>
      </Snackbar>
    </>
  );

  return { openConversation, conversationDialog };
};
